export default __webpack_public_path__ + "static/project-slide-1-2016-765-5efd02029ed4d102d32029df1f7196ce.jpg";